// Fonts are bundled and served from this origin, never a CDN (TMM-T1, TMMPDM-0064). Latin subsets
// only (pt-BR, es and en are all Latin-1); the weights the theme uses: Inter 400/500/600, Mono 400.
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/jetbrains-mono/latin-400.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { BootstrapGate } from './components/BootstrapGate';
import { AppThemeProvider } from './theme/AppThemeProvider';
// Side-effect: initializes i18next with the bundled catalogs.
import './i18n/i18n';

function Root() {
  return (
    <AppThemeProvider>
      {/* enableColorScheme: `.light` / `.dark` set the CSS color-scheme (scrollbars, form controls). */}
      <CssBaseline enableColorScheme />
      <BootstrapGate>
        <RouterProvider router={router} />
      </BootstrapGate>
    </AppThemeProvider>
  );
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');
createRoot(rootEl).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
